<section class="card m-b-16">
    <h4 class="card-title">
        Fixed Pricing Approval Tracker
    </h4>
    <div class="m-t-10 m-b-10">
        <div class="pos-action-divider"></div>
    </div>
    <article class="layout">
        <app-horizontal-steps [states]="requestProgress"></app-horizontal-steps>
        <div  *ngIf="failedRequest" class="error-card m-t-16" >
            <div>
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5C21.9939 18.0203 17.5203 22.4939 12 22.5ZM11 15.5V17.5H13V15.5H11ZM11 7.5V13.5H13V7.5H11Z"
                        fill="#E94444" />
                </svg>
            </div>
            <div class="error-text">
                {{failedRequest && requestProgress[1].status == 'failed' ? "Your request has been declined by State Cordinator.": "Your request has been declined by the Bank."}} <span (click)="openModal()" class="openModal" >View Reason</span>
            </div>
        </div>
    </article>
</section>